<template>
  <v-app-bar color="#5C6BC0"
             id="appBar"
             dark
             app
             :prominent="prominent"
             src="../assets/ECOTECH_Bandeau_1925x170.jpg">
    <v-row dense>
      <v-col cols="4" xl="3" sm="4" md="5" lg="3" align-self="center">
        <v-img id="logoHeader" contain max-width="200px" max-height="150px" src="../assets/RADAR-Ecotech.png"></v-img>
      </v-col>
      <v-col cols="8" xl="9" sm="8" md="7" lg="9">
        <v-toolbar-items>
          <v-row>
            <v-col cols="8" md="10" sm="11" xl="11" lg="11" id="titre" align-self="center">
              {{ GetTrad(102) }}
            </v-col>
            <v-col cols="4" md="2" sm="2" xl="1" lg="1" offset="8" offset-md="0" offset-sm="10" offset-xl="0" align-self="center">
              <v-select id="langue"
                        @input="UpdateLangue"
                        :items="lang"
                        :item-text="selectedLang == 'en' ? 'labelEn' : 'labelFr'"
                        menu-props="auto"
                        label="Traduction"
                        :value="selectedLang"
                        hide-details
                        single-line></v-select>
            </v-col>
          </v-row>
        </v-toolbar-items>
      </v-col>
    </v-row>

  </v-app-bar>
</template>

<script>
  import { mapState, mapGetters, mapActions } from 'vuex'

  export default {
    data () {
      return {
        lang: [
          { value: 'fr', labelFr: 'FR', labelEn: 'FR' },
          { value: 'en', labelFr: 'EN', labelEn: 'EN' }
        ],
        window: { width: window.innerWidth, height: window.innerHeight },
        prominent: true
      }
    },
    created () {
      window.addEventListener('resize', this.handleResize)
      this.handleResize();
    },
    destroyed () {
      window.removeEventListener('resize', this.handleResize)
    },
    computed: {
      ...mapState({
        selectedLang: state => state.Traduction.Langue,
      }),
      ...mapGetters({ GetTrad: 'Traduction/GET_BY_ID' }),
    },
    methods: {
      ...mapActions({
        chargerCasUtilisation: 'ChargerCasUtilisation',
        chargerTraductions: 'Traduction/ChargerTraductions',
        chargerMarcheApplication: 'ChargerMarcheApplication',
        chargerSecteurActivite: 'ChargerSecteurActivite',
        chargerPays: 'ChargerPays',
      }),
      UpdateLangue (e) {
        this.$store.commit('Traduction/SET_LANGUE', e)
      },
      handleResize () {
        this.window.width = window.innerWidth;
        this.window.height = window.innerHeight;
        if (this.window.width < 600) {
          this.extended = false
        } else {
          this.extended = true
        }
        if (this.window.width < 768) {
          //this.justify = 'center'
          //this.offsetSubtitle = 0
          this.prominent = false
        } else {
          // this.justify = 'start'
          //this.offsetSubtitle = 1
          this.prominent = true
        }
      }
    },
    watch: {
      selectedLang: function (val) {
        this.chargerMarcheApplication(val)
        this.chargerSecteurActivite(val)
        this.chargerCasUtilisation(val)
        this.chargerPays(val)
        this.chargerTraductions(val)
      }
    }
  }
</script>

<style>
  #logoHeader {
    margin-left: 100px;
  }

  .v-toolbar__items {
    width: 100%;
  }

  #titre {
    font-family: 'Muli', sans-serif;
    font-weight: 900;
    font-size: 40px !important;
  }

  @media only screen and (max-width:1500px) {
    #titre {
      line-height: normal;
      font-size: 36px !important;
    }

    #logoHeader {
      margin-left: 0px;
    }
  }

  @media only screen and (max-width:1024px) {
    .v-toolbar__items {
      width: 100%;
    }

    #titre {
      line-height: normal;
      font-size: 30px !important;
    }

    #logoHeader {
      margin-left: 0px;
    }

    #appBar .v-toolbar__image .v-image__image {
      background-image: url("../assets/ECOTECH_Bandeau_768x170.jpg") !important;
    }
  }

  @media only screen and (max-width:800px) {
    .v-toolbar__items {
      width: 100%;
      font-size: 36px !important;
    }

    #titre {
      display: none;
    }

    #appBar .v-toolbar__image .v-image__image {
      background-image: url("../assets/ECOTECH_Bandeau_375x130.jpg") !important;
    }
  }
</style>
